import { stAnalytics } from "@storytell/analytics";
import type { FeatureUse } from "@storytell/types";
import { isServer } from "solid-js/web";
import { screenForPath } from "./screenForPath";

export type FeatureAction<F extends FeatureUse["feature"]> = Extract<
  FeatureUse,
  { feature: F; action: unknown }
>["action"];

/**
 * Sends `feature_used` for one user intent. Reads the page from the browser location rather than
 * the router, so services and callbacks outside a component can call it.
 */
export const trackFeature = (use: FeatureUse): void => {
  if (isServer) return;
  stAnalytics.track("feature_used", { ...use, screen: screenForPath(window.location.pathname) }).catch(() => {});
};

/**
 * Also stamps the new value on the person, so insights can segment users by their current
 * setting. Pass a value only when it is an enum, never free text such as a display name.
 */
export const trackSettingChange = (key: FeatureAction<"settings.change">, value?: string): void => {
  trackFeature({ feature: "settings.change", action: key, via: "menu" });
  if (!isServer && value !== undefined) stAnalytics.plugins.posthog.setPersonProperties({ [`setting_${key}`]: value });
};
